import styled from "styled-components";

export const StyledHeading = styled.p`
  color: ${(props) => props.theme.colors.darkGrey};
  font-weight: 400;
  text-align: ${({ $center }) => ($center ? "center" : "left")};
`;
